export const firebaseConfig = {
    apiKey: "AIzaSyCnygWPfZ3ixwvyqQBROAmpTkKIM2VvfRk",
    authDomain: "sale-radius-3af39.firebaseapp.com",
    projectId: "sale-radius-3af39",
    storageBucket: "sale-radius-3af39.firebasestorage.app",
    messagingSenderId: "844243874132",
    appId: "1:844243874132:web:3a2ed48b57f19ee99f58c1"
  };

export const vapIdKey = "BK-dsMKSHWVmtWUjI6sjfhLoS7gYOAj-hAE7PwhfMtMeAxEbghjMl8KB9wb_MvEwEg0oIka2jf0obOU9TLfK4A8";